import { render, staticRenderFns } from "./ShareJobEmail.vue?vue&type=template&id=8a33876a"
import script from "./ShareJobEmail.vue?vue&type=script&lang=js"
export * from "./ShareJobEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports